<script setup lang="ts">
import type { CmsElementQuoteBox } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementQuoteBox;
  class: any;
  style: any;
}>();

const { heading, image, quote } = props.content?.config
</script>

<template>
  <section class="section section-testimonials section-main" :style="props.style" :class="props.class">
    <div class="container">
      <header class="section__head">
        <h2>{{ heading.value }}</h2>
      </header><!-- /.section__head -->

      <div class="section__body">
        <div class="testimonial">
          <div class="testimonial__image">
            <NuxtImg format="webp" loading="lazy" :src="image.value?.url" alt=""></NuxtImg>
          </div><!-- /.testimonial__image -->

          <blockquote class="blockquote">
            <h4>{{ quote.value }}</h4>
          </blockquote>
        </div><!-- /.testimonial -->
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section><!-- /.section section-testimonials -->
</template>